var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.37093C0 0.750511 0.502953 0.247559 1.12338 0.247559H11.8766C12.497 0.247559 13 0.750511 13 1.37093C13 1.99136 12.497 2.49431 11.8766 2.49431H1.12338C0.502952 2.49431 0 1.99136 0 1.37093ZM3.22965 8.48455C3.22965 7.86413 3.7326 7.36117 4.35303 7.36117H8.64694C9.26736 7.36117 9.77031 7.86413 9.77031 8.48455C9.77031 9.10497 9.26736 9.60792 8.64694 9.60792H4.35303C3.7326 9.60792 3.22965 9.10497 3.22965 8.48455ZM2.3498 3.80437C1.72937 3.80437 1.22642 4.30732 1.22642 4.92774C1.22642 5.54817 1.72937 6.05112 2.3498 6.05112H10.6502C11.2707 6.05112 11.7736 5.54817 11.7736 4.92774C11.7736 4.30732 11.2707 3.80437 10.6502 3.80437H2.3498Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.70a3e85411bef422743c203d69f578ce.svg";
export { ForwardRef as ReactComponent };